import React from 'react';
import { Row, Col, Button, Table, Label } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { getNameInCurrentLanguage } from 'helpers/intl';

import SimplePrompt from 'components/layout/SimplePrompt';

import LeadCatcherAdvancedRouteDetails from 'components/layout/lead/LeadCatcherAdvancedRouteDetails';

class LeadCatcherAdvancedRouting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState(prevState => ({ shownIndex: index === prevState.shownIndex ? null : index }));
  };

  closeDetails = () => {
    this.setState({ shownIndex: null });
  };

  addRoute = () => {
    const { entity, changeEntity } = this.props;

    const newRoute = entity.createValue('advancedRouting', []);
    const newValue = entity.getAdvancedRouting().slice();
    newValue.push(newRoute);
    const newEntity = { ...entity.updateValue('advancedRouting', newValue, []) };

    this.setState({ shownIndex: newValue.length - 1 });

    changeEntity(newEntity);
  };

  handleRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeEntry(index);
  };

  removeEntry = index => {
    const { entity, changeEntity } = this.props;

    const newValue = entity.getAdvancedRouting().slice();
    newValue.splice(index, 1);
    const newEntity = { ...entity.updateValue('advancedRouting', newValue, []) };

    if (index < this.state.shownIndex) {
      this.setState(
        prevState => ({ shownIndex: prevState.shownIndex - 1 }),
        () => {
          changeEntity(newEntity);
        }
      );
    } else if (index === this.state.shownIndex) {
      this.setState({ shownIndex: null }, () => {
        changeEntity(newEntity);
      });
    } else {
      changeEntity(newEntity);
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entityLoaded,
      entity,
      changeEntity,
      disabled,
      user,
    } = this.props;
    const { shownIndex } = this.state;

    const columns = [messages.tags, messages.pipeline, messages.actions];
    let tBody = [];
    if (entityLoaded && entity.getAdvancedRouting().length) {
      const advancedRouting = entity.getAdvancedRouting();
      tBody = advancedRouting.map((advancedRoute, i) => {
        return (
          <tr
            key={i}
            className={(i === shownIndex ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(i);
            }}
          >
            <td className="v-align-middle semi-bold">
              {!!advancedRoute.getTags() &&
                !!advancedRoute.getTags().length &&
                advancedRoute.getTags().map(tag => {
                  return (
                    <React.Fragment key={tag}>
                      <Label bsSize="xs" className="m-r-5 m-b-5 inline">
                        {tag}
                      </Label>{' '}
                    </React.Fragment>
                  );
                })}
            </td>
            <td className="v-align-middle">
              {getNameInCurrentLanguage(advancedRoute.getPipeline().getName(), appIntl)}
            </td>
            <td className="v-align-middle text-right">
              {i === shownIndex ? (
                <Button bsSize="sm" className="btn-rounded m-r-10">
                  <i className="fa fa-times" /> {messages.close}
                </Button>
              ) : (
                <Button bsSize="sm" className="btn-rounded m-r-10">
                  <i className="fa fa-pencil-alt" /> {messages.edit}
                </Button>
              )}

              <SimplePrompt
                onSuccess={e => {
                  this.handleRemoveClick(e, i);
                }}
              />
            </td>
          </tr>
        );
      });
    }

    if (shownIndex !== null) {
      const data = entity.getAdvancedRouting()[shownIndex];

      // user wants to see a form
      tBody.splice(
        shownIndex + 1,
        0,
        <tr key={'details-showing-' + shownIndex} className="row-details">
          <td colSpan={columns.length}>
            <LeadCatcherAdvancedRouteDetails
              key={'details-showing-' + shownIndex}
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={changeEntity}
              disabled={disabled}
              user={user}
              data={data}
              colSpan={columns.length}
              index={shownIndex}
            />
          </td>
        </tr>
      );
    }

    return (
      <div className="clearfix padding-20 sm-padding-10">
        {entityLoaded && (
          <Row>
            <Col xs={12}>
              <Table responsive hover className="table-detailed">
                <thead>
                  <tr>
                    {columns.map((column, i) => {
                      return (
                        <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>

              <div className="m-t-10">
                <Button onClick={this.addRoute}>{messages.add_route}</Button>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(LeadCatcherAdvancedRouting));
